import DAO from "../../DAO/DAO";
import Autenticacao from "../../models/Autenticacao";


const login = {
	name: "login",
	path: "/acessar",
	component: () => import("@/views/autenticacao/login/Login.vue"),
	meta: {
		rule: ["public"]
	}
};

const logout = {
	name: "logout",
	path: "/sair",
	beforeEnter(to, from, next) {
		Autenticacao.sair();
		DAO.clear();
        return next({name: 'login'});
    }
};

const recuperarSenha = {
	name: "recuperar-senha",
	path: "/senha/recuperar",
	component: () =>
		import("@/views/autenticacao/recuperar_senha/RecuperarSenha.vue"),
	meta: {
		rule: ["public"]
	}
};

const redefinirSenha = {
	name: "redefinir-senha",
	path: "/senha/redefinir/:pk",
	component: () =>
		import("@/views/autenticacao/redefinir_senha/RedefinirSenha.vue"),
	meta: {
		rule: ["public"]
	}
};


export default [
	login,
	logout,
	recuperarSenha,
	redefinirSenha
]
